import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AccessToken_CreateAccessTokenResult, AccessToken_FieldsFragment } from 'queries';

import Modal from 'common/modal';

type Props = {
  createdAccessTokenResult: Pick<AccessToken_CreateAccessTokenResult, 'privateAccessKeyText'> & {
    accessToken: AccessToken_FieldsFragment;
  };
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

const useStyles = makeStyles(() => ({
  content: {
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    color: '#1C2541',
    overflowWrap: 'anywhere',
  },
  title: {
    fontWeight: 700,
    fontSize: '24px',
    marginTop: '18px',
    alignSelf: 'center',
  },
}));

export default function CreateAccessTokenSuccessModal({
  createdAccessTokenResult,
  setShowModal,
  showModal,
}: Props) {
  const classes = useStyles();

  const onExitClick = () => {
    setShowModal(false);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <div className={classes.content}>
          <Typography className={classes.title}>Access Token Details</Typography>
          <p>
            Please copy your Token Name, Public Token, and Private Key and store in a secure
            location.{' '}
            <strong>
              The Private Key will only be visible this once and can never be retrieved again.
            </strong>
          </p>
          <p>
            <strong>Token Name:</strong> {createdAccessTokenResult.accessToken.name}
          </p>
          <p>
            <strong>Public Token:</strong> {createdAccessTokenResult.accessToken.publicAccessToken}
          </p>
          <p>
            <strong>Private Key:</strong> {createdAccessTokenResult.privateAccessKeyText}
          </p>
        </div>
      }
      loading={false}
      actionDisabled={false}
      maxWidth="sm"
    />
  );
}
